var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['el-dialog-menu-nav-item', _vm.isActive ? 'is-active' : '' ],on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }